import "./Tag.scss";

const TagPrimium = ({ text, absoluteTopLeft }) => {
  return (
    <div className={`tag--primium ${absoluteTopLeft?"absolute--top-left":""}`} >
      <span>{text}</span>
    </div>
  );
};

export default TagPrimium;
